import React from 'react';

const ImagePreview = ({ fileName }) => {
	return (
		<div className="image-preview">
			<img src={`${starterTemplates.imageDir}${fileName}`} />
		</div>
	)
}

export default ImagePreview;
